import { useEffect } from "react";

import { iterable } from "@/features/iterable/stores/iterable.store";
import { IterableEmbeddedMetadata } from "@iterable/web-sdk";

/**
 * Counts an impression for as long as the message is on screen. The duration is
 * batched into the `embeddedSession` event when the session ends.
 */
export const useEmbeddedImpression = ({
  messageId,
  placementId,
}: IterableEmbeddedMetadata) => {
  useEffect(() => {
    iterable.startImpression(messageId, placementId);

    /** Unmounted, stop counting. */
    return () => {
      iterable.pauseImpression(messageId);
    };
  }, [messageId, placementId]);
};
